// 发送日志
function postTceLog(api, url, reqData, tceLogServer) {
  // 只统计console和V2的接口
  var isConsole = /cgi/.test(api);
  var isV2 = /capi\/v2/.test(api);

  if(api && (isConsole || isV2)) {
    $.ajax({
      type: "post",
      url: tceLogServer,
      xhrFields: {
        withCredentials: false,
      },
      data: JSON.stringify({ api: api, url: url, type: "api", detail: { apiReqData: reqData }}),
      dataType: "json",
      contentType: "application/json; charset=utf-8",
      success: function (resp) {
        // console.log("resp", resp);
      },
      error: function (error) {
        console.log("error", error);
      },
    });
  }
}

// 非云API请求抓取
function nonStandardApiCollect(tceLogServer) {
  let originOpen = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function (...args) {
    this.__open_url = args[1];
    return originOpen.apply(this, args);
  };
  let originSend = XMLHttpRequest.prototype.send;
  XMLHttpRequest.prototype.send = function (...args) {
    // 获取API请求的内容,post请求
    if(this.__open_url && args && args.length > 0) {
      postTceLog(this.__open_url, location.href, args[0], tceLogServer);
    }
    return originSend.apply(this, args);
  };
}

export const init = () => {
  // 获取弹性变量里面的tce_log_server
  var tceLogServer = window.tcesdk && window.tcesdk.config && window.tcesdk.config.getElasticConfig && window.tcesdk.config.getElasticConfig("tce_log_server") || '';
  if(tceLogServer) {
    nonStandardApiCollect(tceLogServer)
  }
}